import React, { useRef, useState } from "react";
import PropTypes from 'prop-types';
import { format } from "date-fns";

import { Button } from "react-bootstrap";
     
import { GetLanguageId, Translate } from "../Translator";
import { GetDatasourceName } from "../Datasources/Datasources"
import { ConfigurationApiIntegrationEnable, ConfigurationApiIntegrationSetAlertEmail, ConfigurationApiIntegrationSynchronizeNow, ConfigurationApiCheckScheduler } from "../../ExternalApi/ConfigurationApi.js"
import { IsEmptyString } from "../GeneralFunctions.jsx"

import { GetDatasourceLive } from "../Datasources/Datasources.jsx";

import IntegrationWizardStepHeader from "../IntegrationWizard/IntegrationWizardStepHeader.jsx";
import MainIntegrationSyncInfo from "./MainIntegrationSyncInfo.jsx"

import NotificationTopPng from '../../Assets/NotificationTop.png';
import NotificationBottomPng from '../../Assets/NotificationBottom.png';

const MainIntegration = (props) => {

  const mCheckSecondsRef = useRef(1);

  const [mAlertEmail, SetAlertEmail] = useState(props.Integration.AlertEmail ?? "")
  const [mAlertEmailEdit, SetAlertEmailEdit] = useState(false)

  const CurrentSynchronizedString = (recordCount, synchronizedTimeStamp) => {
    if ((synchronizedTimeStamp === null) || (synchronizedTimeStamp === ""))
    {
      return Translate("Not synchronized yet") 
    }
  
    let line = Translate("Current set: <count> phone number records").replace("<count>",recordCount)
  
    //const msSince = Date.parse(synchronizedTimeStamp + "+0:00") //This is a utc time. Force it to be recognized as such
    const msSince = Date.parse(synchronizedTimeStamp.replace(' ', 'T') + 'Z') //This is a utc time. Force it to be recognized as such
    const msNow = new Date() //Means now
  
    let diff = Math.floor((msNow - msSince) / 60000)
    if (diff < 1)
    {
      return line + " (just now)"
    }
    else if (diff === 1)
    {
      return line + " (" + diff + " " + Translate("minute ago") + ")"
    }
    else if (diff < 120)
    {
      return line + " (" + Translate("<minutes> minutes ago").replace("<minutes>",diff) + ")"
    }
    else
    {
      diff = Math.floor(diff / 60)
      if (diff < 48)
      {
        return line + " (" + Translate("<hours> hours ago").replace("<hours>",diff) + ")"
      }
      else
      {
        diff = Math.floor(diff / 24)
        return line + " (" + Translate("<days> days ago").replace("<days>",diff) + ")"
      }
    }
  }

  const NextUpdateString = (nextUpdateTimeString) => 
  {
    if (nextUpdateTimeString)
    {
      let line = Translate("Automatic synchronization in") + " "

      const msUntil = Date.parse(nextUpdateTimeString + "+0:00") //This is a utc time. Force it to be recognized as such
      const msNow = new Date() //Means now

      let diff = Math.ceil((msUntil - msNow) / 60000)
      if (diff < 2)
      {
        return line + "1 " + Translate("minute")
      }
      else if (diff < 120)
      {
        return line + diff + " " + Translate("minutes")
      }
      else
      {
        diff = Math.ceil(diff / 60)
        if (diff < 48)
        {
          return line + diff + " " + Translate("hours")
        }
        else
        {
          diff = Math.ceil(diff / 24)
          return line + diff + " " + Translate("days")
        }
      } 
    }
    else
    {
      return Translate("Next synchronization could not be determined")
    } 
  }

  const ReplaceFields = (aLine) => {

    let bodyLine = aLine

    bodyLine = bodyLine.replace("#(Caller number)","0123456789")
    bodyLine = bodyLine.replace("#(Caller name)","John Doe")
    bodyLine = bodyLine.replace("#(Device number)","100")
    bodyLine = bodyLine.replace("#(Device name)","Employee 100")
    bodyLine = bodyLine.replace("#(Ddi number)","100")
    bodyLine = bodyLine.replace("#(Ddi name)","Ddi 100")
    bodyLine = bodyLine.replace("#(Last contact)","Thomas, 24-06-2025 14:37")
    bodyLine = bodyLine.replace("#(Start time)",format(new Date(), "yyyy-MM-dd HH:mm:ss"))
    bodyLine = bodyLine.replace("#(Application name)",props.Integration.ApplicationName)

    {props.Integration.DatasourceFields.map((field) => 
      bodyLine = bodyLine.replace("$(" + field.FieldLabel + ")",field.DefaultTestValue)
      )}      
    
    return bodyLine
  }

  const IntegrationEnable = async (integrationGuid, flag) => {
    if (props.SecurityToken !== "")
    {
      const newIntegrations = await ConfigurationApiIntegrationEnable(props.SecurityToken, integrationGuid, flag, props.UserName) 
      if (newIntegrations !== null) 
      {
        props.OnIntegrationsChanged(newIntegrations)
      }
      else
      {
        alert(Translate("Failed to update the integration"))
      } 
    }
    else
    {
      alert(Translate("Failed to update the integration"))
    }
  }

  const RefreshIntegrations = () => {
    props.OnIntegrationsRefresh()
  }

  const SetAlertEmailToUserEmail = () => {
    SetAlertEmail(props.UserEmail)
  }

  const IntegrationChangeAlertEmail = async () => {
    
    SetAlertEmailEdit(false)
    if (props.SecurityToken !== "")
    {
      const newIntegrations = await ConfigurationApiIntegrationSetAlertEmail(props.SecurityToken, props.Integration.IntegrationGuid, mAlertEmail, "")
      mCheckSecondsRef.current = 1
      if (newIntegrations !== null) 
      {
        props.OnIntegrationsChanged(newIntegrations)
      }
      else
      {
        alert(Translate("Failed to update the integration"))
      } 
    }
    else
    {
      alert(Translate("Failed to update the integration"))
    }
  }

  const IntegrationDeleteAlertEmail = async () => {
    
    if (props.SecurityToken !== "")
    {
      const newIntegrations = await ConfigurationApiIntegrationSetAlertEmail(props.SecurityToken, props.Integration.IntegrationGuid, "", "") 
      mCheckSecondsRef.current = 1
      if (newIntegrations !== null) 
      {
        props.OnIntegrationsChanged(newIntegrations)
      }
      else
      {
        alert(Translate("Failed to update the integration"))
      } 
    }
    else
    {
      alert(Translate("Failed to update the integration"))
    }
  }

  const IntegrationSynchronizeNow = async (integrationGuid) => {
    if (props.SecurityToken !== "")
    {
      const newIntegrations = await ConfigurationApiIntegrationSynchronizeNow(props.SecurityToken, integrationGuid) 
      await ConfigurationApiCheckScheduler(props.SecurityToken, integrationGuid)
      mCheckSecondsRef.current = 1
      if (newIntegrations !== null) 
      {
        props.OnIntegrationsChanged(newIntegrations)
      }
      else
      {
        alert(Translate("Failed to update the integration"))
      } 
    }
    else
    {
      alert(Translate("Failed to update the integration"))
    }
  }
  
  const BrandingColor = sessionStorage.getItem("BrandingColor")  
  const BrandingId = sessionStorage.getItem("BrandingId")
  const IsLive = GetDatasourceLive(props.Integration.DatasourceType)
  
  return (
    <span>
      <IntegrationWizardStepHeader Header={props.Integration.ApplicationName}/>

      <div className="surface namevalue">
        <table width="100%" cellPadding={16}>
        <tbody>
        {
          props.Integration.CreatorComputerName ?
            <tr>
              <td className="namevaluenamecolumn surfacedividerbottom" valign="center">{Translate("Source info")}</td>
              <td colSpan="2" className="surfacedividerbottom" valign="center">
                {Translate("Recognition from")} {GetDatasourceName(props.Integration.DatasourceType)}
                <span className="graytext">&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;{Translate("Integrations created with the desktop configurator can only be changed with the desktop configurator from the same computer.")}<br/>{Translate("Can be modified from computer") + " " + props.Integration.CreatorComputerName}</span>
              </td>
            </tr> 
            :
            <tr>
              <td className="namevaluenamecolumn surfacedividerbottom" valign="center">{Translate("Source info")}</td>
              <td className="surfacedividerbottom" valign="center">{Translate("Recognition from")} {GetDatasourceName(props.Integration.DatasourceType)}</td>
              <td className="surfacedividerbottom" valign="top"><Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => props.OnOpenPopupFullscreen("/IntegrationWizard?Action=update&After=&SecurityToken=" + props.SecurityToken + "&languageid=" + GetLanguageId() + "&integrationguid=" + props.Integration.IntegrationGuid)}>{Translate("Configure")}</Button></td>
            </tr> 
        }
        <tr>
          <td width="200" className="namevaluenamecolumn surfacedividerbottom" valign="center">{Translate("Location info")}</td>
          <td width="*" className="surfacedividerbottom" valign="center">{Translate("Database country code")}: +{props.Integration.NumberSettings.CountryCode}</td>
          <td width="100" className="surfacedividerbottom" valign="top">
            <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => props.OnOpenPopupFullscreen("/IntegrationWizard?Action=setcountrycode&After=&SecurityToken=" + props.SecurityToken + "&languageid=" + GetLanguageId() + "&integrationguid=" + props.Integration.IntegrationGuid)}>{Translate("Configure")}</Button>  
          </td>
        </tr>
        <tr>
          <td className="namevaluenamecolumn surfacedividerbottom" valign="top">{Translate("Client call notification")}</td>
          <td className="surfacedividerbottom" valign="top">

            <table width="100%" cellPadding="0" cellSpacing="0">
            <tbody>
            <tr height="6" className="smallrow">
              <td width="533" height="6" colSpan={3}><img src={NotificationTopPng} style={{backgroundColor: BrandingColor}}/></td>
              <td width="*"/>
            </tr>
            <tr>
              <td width="6" style={{backgroundColor: BrandingColor}}></td>
              <td width="521" className="notificationpreview">
                  <div className="notificationpreviewheader surfacedividerbottom">{props.Integration.NotificationTemplate.Header}</div>
                  {props.Integration.NotificationTemplate.Body.map((line,index) => 
                    <div className="notificationpreviewbody surfacedividerbottom" key={index}>{ReplaceFields(line).trim() === "" ? <span className="graytext">{Translate("<empty line>")}</span> : ReplaceFields(line)}</div>
                  )}
              </td>
              <td width="6" style={{backgroundColor: BrandingColor}}></td>
              <td/>
            </tr>
            <tr height="64">
              <td colSpan="3"><img src={NotificationBottomPng} style={{backgroundColor: BrandingColor}}/></td>
              <td/>
            </tr>
            </tbody>
            </table> 

          </td>
          <td className="surfacedividerbottom" valign="top">
            <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => props.OnOpenPopupFullscreen("/IntegrationWizard?Action=setnotification&After=&SecurityToken=" + props.SecurityToken + "&languageid=" + GetLanguageId() + "&integrationguid=" + props.Integration.IntegrationGuid)}>{Translate("Configure")}</Button>  
          </td>
        </tr>
        <tr>
          <td className="namevaluenamecolumn surfacedividerbottom" valign="center">{Translate("Actions")}</td>
          <td className="surfacedividerbottom" valign="center">
          {props.Integration.Scripts?.map((script, i) => (
              <div key={i} style={script.Enabled ? {} : { color: "grey"}}>{script.Name}</div>
          ))}

          </td>
          <td className="surfacedividerbottom" valign="top">
            <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => props.OnOpenPopupFullscreen("/IntegrationWizard?Action=setscripts&After=&SecurityToken=" + props.SecurityToken + "&languageid=" + GetLanguageId() + "&integrationguid=" + props.Integration.IntegrationGuid)}>{Translate("Configure")}</Button>  
          </td>
        </tr>
        <tr>
          <td className="namevaluenamecolumn surfacedividerbottom" valign="top">{Translate("Synchronization info")}</td>
          <td className="surfacedividerbottom" valign="top">
            
            {props.Integration.Enabled && !IsLive ? <div>{CurrentSynchronizedString(props.Integration.RecordCount, props.Integration.SynchronizedTimeStamp)}</div> : ""}

            {!props.Integration.Enabled ? <b>{Translate("This integration is disabled")}</b> :
              (IsLive ? <div>{Translate("This application uses live search and does not need synchronization")}</div> : 
                <MainIntegrationSyncInfo SecurityToken={props.SecurityToken} IntegrationGuid={props.Integration.IntegrationGuid} AutoSync={(props.Integration.AutoUpdateFlags !== "") && (props.Integration.AutoUpdateFlags !== "none") && (props.Integration.AutoUpdateFlags !== "never")} NextSync={props.Integration.NextUpdate} LastSynced={props.Integration.SynchronizedTimeStamp} LastError={props.Integration.Enabled && !IsLive && props.Integration.LastUpdateRemark ? props.Integration.LastUpdateRemark : ""} CheckSecondsRef={mCheckSecondsRef} OnIntegrationsRefresh={RefreshIntegrations}/>
            )}
          </td>
          <td className="surfacedividerbottom" valign="top">
            <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => IntegrationSynchronizeNow(props.Integration.IntegrationGuid)} style={{ textAlign: "left" }}>{Translate("Sync now")}</Button>
            <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => IntegrationEnable(props.Integration.IntegrationGuid, !props.Integration.Enabled)}>{props.Integration.Enabled ? Translate("Disable") : Translate("Enable")}</Button>  
          </td>
        </tr>
        { IsEmptyString(props.Integration.CreatorComputerName) && !IsLive && props.Integration.Enabled && ((props.Integration.AutoUpdateFlags !== "") && (props.Integration.AutoUpdateFlags !== "none") && (props.Integration.AutoUpdateFlags !== "never")) ? 
          <tr>
            <td className="namevaluenamecolumn surfacedividerbottom" valign="center">{Translate("Error alert")}</td>
            <td className="surfacedividerbottom" valign="center">
              {mAlertEmailEdit ? 
                <>
                  <div className="wizardfieldname">{Translate("Alert email").toUpperCase()}</div>
                  <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={mAlertEmail} onChange={evt => SetAlertEmail(evt.target.value)} className="wizardinputfield"/></div>
                  <Button style={{marginTop: -4, paddingTop: 5, paddingBottom: 5}} variant="dark" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => IntegrationChangeAlertEmail()}>{Translate("OK").toUpperCase()}</Button>
                  <Button style={{marginTop: -4, paddingTop: 5, paddingBottom: 5}} variant="dark" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => { SetAlertEmailEdit(false); SetAlertEmail(props.Integration.AlertEmail ?? "")}}>{Translate("Cancel").toUpperCase()}</Button>
                  <Button style={{marginTop: -13}} variant="link" size="sm" className="mainconfigurebutton" onClick={() => SetAlertEmailToUserEmail()}>{Translate("Use")} {props.UserEmail}</Button> 
                </> :
                (props.Integration.AlertEmail ? 
                  <>{Translate("If the integration fails to synchronize, an email will be sent to: <email>").replace("<email>",props.Integration.AlertEmail)}.</> :
                  <>{Translate("Configure to send an email when synchronization fails")}.<br/>{Translate("No email is currently configured")}.</>
                )
              }
            </td>
            <td className="surfacedividerbottom" valign="top">
            {mAlertEmailEdit ? 
              <></> :
              <>
                <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => SetAlertEmailEdit(true)}>{Translate("Configure")}</Button>  
                {props.Integration.AlertEmail ? <Button variant="link" size="sm" className="mainconfigurebutton" onClick={() => IntegrationDeleteAlertEmail()}>{Translate("Remove")}</Button> : <></>} 
              </>
            }
            </td>
          </tr> :
          <></>
        }
        <tr>
          <td/>
          <td/>
          <td colSpan={3} valign="top">
            <Button variant="dark" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => props.OnIntegrationDelete(props.Integration.IntegrationGuid)}>{Translate("Delete").toUpperCase()}</Button> 
          </td>
        </tr>      
        </tbody>
        </table>
      </div>
    </span>  
  )
}

MainIntegration.propTypes = {
  SecurityToken: PropTypes.string,
  UserName: PropTypes.string,
  UserEmail: PropTypes.string,
  Integration: PropTypes.any,
  History: PropTypes.any,
  OnOpenPopupFullscreen: PropTypes.func,
  OnIntegrationDelete: PropTypes.func,
  OnIntegrationsChanged: PropTypes.func,
  OnIntegrationsRefresh: PropTypes.func
}

export default MainIntegration